__webpack_require__.p = "/wp-content/plugins/tribu_locations/frontend/public/";